export enum LanguageEnum {
  CS = "cs",
  EN = "en",
}
